const month = new Map<number, string>([
  [1, 'Jan'],
  [2, 'Feb'],
  [3, 'Mar'],
  [4, 'Apr'],
  [5, 'May'],
  [6, 'Jun'],
  [7, 'Jul'],
  [8, 'Aug'],
  [9, 'Sep'],
  [10, 'Oct'],
  [11, 'Nov'],
  [12, 'Dec'],
]);

export const formatDate = (date: string): string => {
  const dateSplit = date.split('-');
  return `${month.get(Number(dateSplit[1]))} ${Number(dateSplit[2])} ${dateSplit[0]}`;
};
